import { type Dispatch, type SetStateAction, useState } from 'react';

function useFilterState<T>(initialValues: T): {
  values: T;
  setValues: Dispatch<SetStateAction<T>>;
  reset: () => void;
} {
  const [values, setValues] = useState<T>(initialValues);

  const reset = () => {
    setValues(initialValues);
  };

  return { values, setValues, reset };
}

export default useFilterState;
